import { render, staticRenderFns } from "./Dbugga.vue?vue&type=template&id=c2b30f7c&scoped=true"
import script from "./Dbugga.vue?vue&type=script&lang=js"
export * from "./Dbugga.vue?vue&type=script&lang=js"
import style0 from "./Dbugga.vue?vue&type=style&index=0&id=c2b30f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b30f7c",
  null
  
)

export default component.exports